declare global {
  interface Window {
    env: any
  }
}

// change with your own variables
interface EnvType {
  REACT_APP_EDLINK_CLIENT_ID: string
  REACT_APP_AWS_ENVIRONMENT: string
  REACT_APP_SUMMARIZATION_API_URL: string
  REACT_APP_SUMMARIZATION_API_KEY: string
}
export const env: EnvType = { ...process.env, ...window.env }
